<div class="[&_a]:underline">
  <transloco id="c1a2978f-f69c-404b-b880-05c3908d8854" *ngIf="message" [key]="message.key" [params]="message.params" [scope]="message.scope"></transloco>
  <div *ngIf="staticMessage" [innerHTML]="staticMessage"></div>
</div>
